import { render, staticRenderFns } from "./ItfForm.vue?vue&type=template&id=6159a77c"
import script from "./ItfForm.vue?vue&type=script&lang=js"
export * from "./ItfForm.vue?vue&type=script&lang=js"
import style0 from "./ItfForm.vue?vue&type=style&index=0&id=6159a77c&prod&lang=scss"
import style1 from "./ItfForm.vue?vue&type=style&index=1&id=6159a77c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports